import { PORTAL } from "src/constants/AppConstants";
const appSettings = {
    'appId':'93',
    'appName':'boffin'
}

export default appSettings;